import { render, staticRenderFns } from "./AddLimitsDialog.vue?vue&type=template&id=5b06210e&scoped=true"
import script from "./AddLimitsDialog.vue?vue&type=script&lang=js"
export * from "./AddLimitsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b06210e",
  null
  
)

export default component.exports